// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3qG37","title":"Info_title__2Ra4A","selects":"Info_selects__39PNu","requiredAsterisk":"Info_requiredAsterisk__2FQvL"};